import React, { useEffect, useRef } from "react";
import BildirimContainer from "../pages/Bildirimler/BildirimContainer";
import { Link } from "react-router-dom";

const NotificationPopup = ({ setNotificationOpen, setRatingIsOpen }) => {
  const popupRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setNotificationOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={popupRef}
      className="border-2 border-lineGray rounded-2xl w-[393px] max-h-[400px] z-[1000] bg-whiteBg flex flex-col"
    >
      <div className="flex justify-between p-4 border-b border-lineGray">
        <p className="text-base font-semibold text-dark">Bildirimler</p>
        <Link to="/bildirimler">
          <span className="text-darkBlue text-xs font-medium">Tümünü Gör</span>
        </Link>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-lineGray scrollbar-track-transparent hover:scrollbar-thumb-grayy">
        <BildirimContainer setRatingIsOpen={setRatingIsOpen} isPopup={true} />
      </div>
    </div>
  );
};

export default NotificationPopup;
